import MainLayout from '@/common/components/layouts/MainLayout';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import Stepper from '@/modules/adjusterReportModules/IncidentParticipants/components/common/Stepper';
import { culpritSterOwnerData } from '@/modules/adjusterReportModules/IncidentParticipants/data/stepsData';
import { IOwnerInformationForm } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQuery.type';
import { getOwnerInformationQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getOwnerInformation/getOwnerInformationQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { PropsWithChildren, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

export default ({ children }: PropsWithChildren) => {
  return (
    <MainLayout title="مقصر / مالک" header="closeHeader">
      <CulpritOwnerInfo>{children}</CulpritOwnerInfo>
    </MainLayout>
  );
};

const CulpritOwnerInfo = ({ children }: PropsWithChildren) => {
  const { id } = useParams();

  const { data: ownerInformation } = useQuery(
    getOwnerInformationQueryOptions({ id: +id! }),
  );
  const methods = useForm<IOwnerInformationForm>({
    mode: 'onChange',
  });

  useEffect(() => {
    if (ownerInformation) {
      methods.reset({
        ...ownerInformation,
        personal_information: {
          ...ownerInformation.personal_information,
          birthdate:
            ownerInformation.personal_information?.birthdate.toString(),
          owner_type: ownerInformation.personal_information?.owner_type.value,
          gender: ownerInformation.personal_information?.gender.value,
        },
      });
    }
  }, [methods, ownerInformation]);

  return (
    <>
      <Box width="100%" pt={'24px'}>
        <Stepper steps={culpritSterOwnerData} width="80%" />
      </Box>
      <Box
        w="100%"
        mx="auto"
        mt={40}
        mb={24}
        border="1px solid"
        borderColor="gray-2"
      ></Box>
      <Box width="100%">
        <FormProvider {...methods}>
          <>{children}</>
        </FormProvider>
        <ImagesFabMainModal state={'propertyCulprit'} />
      </Box>
    </>
  );
};
